import {
  TOGGLE_MODAL_EMAIL_SENT,
} from '../actions/emailSentModalActions';

const initialState = {
  isOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MODAL_EMAIL_SENT:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}
